import { client } from '@services/api/sparkecommerce/client'

export type DirectPurchaseMethod = 'credit_card' | 'pix'

export interface IDirectPurchaseContext {
  offer: {
    id: number
    title: string
    kind: string
    payment_methods: DirectPurchaseMethod[]
    price_cents: number
    pix_price_cents: number
  }
  // Preenchido quando o painel não sabe vender a oferta: o aluno segue para o checkout.
  checkout_reason: 'missing_document' | 'unsupported_offer' | null
  installments?: {
    installments: number
    installment_amount_cents: number
    total_cents: number
  }[]
  cards?: { id: string; brand: string; last_digits: string }[]
}

export interface IDirectPurchaseStatus {
  status:
    | 'processing'
    | 'completed'
    | 'failed'
    | 'waiting_payment'
    | 'waiting_three_ds'
  pix?: { pix_qr_code: string; expiration_at?: string }
  error_code?: string
  error_message?: string
}

export interface ICreateDirectPurchase {
  payment_method: DirectPurchaseMethod
  saved_card_id?: string
  installments?: number
  consent: boolean
  expected_price_cents: number
  // De onde o painel foi aberto; o sparkecommerce grava como utm_content do carrinho.
  entry?: 'home_section' | 'next_learning'
}

const auth = (token: string | null) => ({
  headers: { Authorization: `Bearer ${token}` },
})

export function getDirectPurchase(offerId: string, token: string | null) {
  return client.get<IDirectPurchaseContext>(
    `/members_api/direct_purchases/${offerId}`,
    auth(token),
  )
}

export function createDirectPurchase(
  offerId: string,
  body: ICreateDirectPurchase,
  token: string | null,
) {
  return client.post<{ session_id: string; attempt_id: string }>(
    `/members_api/direct_purchases/${offerId}`,
    body,
    auth(token),
  )
}

// Antes de o worker criar o carrinho o status responde 404: ainda processando.
export function getDirectPurchaseStatus(
  sessionId: string,
  attemptId: string,
  token: string | null,
) {
  return client.get<IDirectPurchaseStatus>(
    `/members_api/direct_purchases/status/${sessionId}`,
    {
      ...auth(token),
      params: { attempt_id: attemptId },
      validateStatus: (s) => s < 500,
    },
  )
}
